import { Card, CardContent } from '@/components/ui-kit/card';
import { AgentSummary } from '@/modules/gpt-chats/types/agent.service.type';
import { AgentCardDropDown } from './agent-card-dropdown';
import { Link } from 'react-router-dom';

export const AgentCardListView = ({ agent }: { agent: AgentSummary }) => {
  return (
    <Card className="group flex h-auto items-center gap-4 self-stretch rounded-lg border-border/40 p-4 shadow-none transition-all duration-200 hover:border-border hover:bg-accent/50 hover:shadow-sm [&:has([data-state=open])]:bg-accent/50 relative">
      <CardContent className="flex w-full items-center gap-4 p-0">
        <Link
          to={`/ai/agent-details/${agent.id}`}
          className="flex flex-1 items-center gap-4 min-w-0"
        >
          <div className="relative h-12 w-12 flex-shrink-0 overflow-hidden rounded-lg bg-muted/30 flex items-center justify-center">
            <img
              src={agent.logo_url || '@/assets/images/agents/widget.png'}
              alt={agent.name}
              className="h-full w-full object-cover"
              onError={(e) => {
                e.currentTarget.src = '@/assets/images/agents/widget.png';
              }}
            />
          </div>
          <div className="flex min-w-0 flex-1 flex-col gap-0.5 pr-8">
            <h3
              className="text-base font-semibold leading-tight text-foreground truncate"
              title={agent.name}
            >
              {agent.name}
            </h3>
            <p className="line-clamp-1 text-sm text-muted-foreground" title={agent.description}>
              {agent.role || agent.description}
            </p>
          </div>
        </Link>
        <div
          className="invisible absolute right-4 group-hover:visible group-[&:has([data-state=open])]:visible"
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <AgentCardDropDown agent={agent} />
        </div>
      </CardContent>
    </Card>
  );
};
